module.exports = function (element) {

    function downloadImgBlock(el) {
        let img = $(el).find('img');
        let width = parseInt(img.data('width'))

        let clicker
        img.on('click', function () {
            clicker = setTimeout((function () {
                img.attr('width', function (_, attr) {
                    return parseInt(attr) === 100 ? width : '100%'
                });

                $('html, body')
                    .animate({scrollTop: img.offset().top}, 20)
                    .animate({scrollLeft: img.offset().left}, 20)
            }), 250)

            return false
        })

        img.on('dblclick', function () {
            if (clicker) {
                clearTimeout(clicker);
            }

            top.location.href = img.attr('src') + '?d=1';
            return false
        })

    }

    if (!element) {
        throw new Error('Element undefined');
    }

    downloadImgBlock(element);
};
